module.exports = __webpack_public_path__ + "img/intro.95572a39.png";